<div class="holder">
  <h1>SMS Gönder</h1>
  <div
    style="display: flex; flex-direction: row; gap: 1rem; margin-bottom: 1rem"
  >
    <button class="btn btn-secondary" (click)="downloadTemplate()">
      Örnek Excel İndir
    </button>
    <button class="btn btn-primary" (click)="fileInput.click()">
      Excel Yükle
    </button>
    <button class="btn btn-primary" (click)="downloadAllSms()">
      Tüm SMS Gönderme İşlemlerini İndir
    </button>
    <button class="btn btn-warning" (click)="sendToIys()">
      Numaraları İYS'ye Gönder
    </button>
    <div style="flex: 1"></div>
    <button class="btn btn-danger" (click)="clear()">Temizle</button>
  </div>
  <div class="form-control-holder">
    <label for="">Telefon Numaraları (Virgülle ayırınız)</label>
    <textarea [(ngModel)]="phonesText"></textarea>
  </div>
  <div class="form-control-holder">
    <label for="">Mesaj</label>
    <textarea [(ngModel)]="content"></textarea>
  </div>
  <app-button text="Gönder" (click)="sendSms()"></app-button>
</div>

<div class="holder" style="margin-top: 2rem" *ngIf="loading">
  <div class="loader-container">
    <app-loader></app-loader>
  </div>
</div>

<div class="holder result-holder" style="margin-top: 2rem">
  <h1>SMS Gönderim Sonuçları</h1>
  <button class="btn btn-primary" (click)="downloadOutputExcel()">
    Excel Olarak İndir
  </button>
  <div class="table-holder">
    <table class="table table-hover table-bordered">
      <thead>
        <tr>
          <th>Telefon Numarası</th>
          <th>Sonuç</th>
          <th>Hata Mesajı</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of output">
          <td>{{ item.phone }}</td>
          <td>{{ item.isSuccess ? "Başarılı" : "Başarısız" }}</td>
          <td>{{ item.errorMessage }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="holder result-holder" style="margin-top: 2rem">
  <h1>İYS'ye Gönderim Sonuçları</h1>
  <button class="btn btn-primary" (click)="downloadIysOutputExcel()">
    Excel Olarak İndir
  </button>
  <div class="table-holder">
    <table class="table table-hover table-bordered">
      <thead>
        <tr>
          <th>Telefon Numarası</th>
          <th>Sonuç</th>
          <th>Hata Mesajı</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of iysOutput">
          <td>{{ item.phone }}</td>
          <td>{{ item.isSuccess ? "Başarılı" : "Başarısız" }}</td>
          <td>{{ item.errorMessage }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<input
  type="file"
  #fileInput
  style="display: none"
  accept=".xlsx,.xls"
  (change)="handleFileUpload($event)"
/>
